"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m14.0366 4.1885 5.9658 4.2934V14h-2V9.9942H6.0004l.0018 8.0001h1.998v2H4.0026L4 8.482l5.9658-4.2935 1.1683 1.6233-3.0325 2.1824h7.7993l-3.0326-2.1824 1.1683-1.6233z"
  }), _react.default.createElement("path", {
    d: "M14.0029 14h-4v-2h4v2zM13 16l-3 3 3 3v-2h6v2l3-3-3-3v2h-6v-2z"
  })];
};

exports.default = _default;